import React, { useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
import { mentorData } from "../data/Mentor";
import Footer from "../partials/Footer";
import Header from "../partials/Header";
import MobileSideFilter from "../partials/MobileSideFilter";
import SideFilter from "../partials/SideFilter";

function MentorDisplay({ match }) {
  const [searchTerm, setSearchTerm] = useState("");
  const [mentor, setMentor] = useState();
  const history = useHistory();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  useEffect(() => {
    setMentor({ ...mentorData?.find((dat) => dat.id === match.params.id) });
  }, [match.params.id]);

  const redirectHome = () => {
    history.push("/");
  };

  return (
    <div>
      <Header />

      <div className="body__container">
        <div className="bread__crump">
          <i
            className="fa fa-home"
            aria-hidden="true"
            style={{ cursor: "pointer" }}
            onClick={() => redirectHome()}
          />{" "}
          / {mentor?.name}
        </div>
        <div className="">
          <div className="side__sub">
            <MobileSideFilter setSearchTerm={setSearchTerm} />
          </div>
          <div className="header__text">{mentor?.name}</div>
          <div className="body__content">
            <div className="side__main">
              <SideFilter setSearchTerm={setSearchTerm} />
            </div>
            <div className="display__container2 row col-12 col-sm-10 ">
              <div className="col-md-12">
                <div className="col-sm-12 col-12 start__cont start__cont2">
                  <img
                    src={mentor?.profile}
                    alt=""
                    style={{ marginBottom: 10 }}
                  />
                  <h5>
                    <strong>{mentor?.name}</strong>
                  </h5>
                  <button
                    style={{ marginBottom: 30 }}
                    className="connect__btn"
                    // onClick={() => setModal(true)}
                  >
                    Connect now
                  </button>
                  <div style={{ textAlign: "justify" }}>{mentor?.desc}</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="main__footer">
        <Footer />
      </div>
    </div>
  );
}

export default MentorDisplay;
